import LegalShell, { Section } from "@/components/LegalShell";

const Terms = () => {
  return (
    <div data-testid="terms-page">
      <LegalShell title="Terms of Service" updated="June 2026">
        <p className="text-zinc-400 leading-relaxed">
          These Terms of Service ("Terms") govern your access to and use of IndieLaunchkit (the "Service"). By creating
          an account or using the Service, you agree to these Terms.
        </p>

        <Section heading="1. The Service">
          <p>IndieLaunchkit provides AI-assisted tools for indie game developers to generate Steam patch notes, changelogs, and store page copy. The Service is provided on an "as is" and "as available" basis.</p>
        </Section>

        <Section heading="2. Accounts">
          <p>You must sign in with a valid Google account and be at least 16 years old (or the age of digital consent in your jurisdiction). You are responsible for activity under your account and for keeping your access secure.</p>
        </Section>

        <Section heading="3. Ownership of Generated Content">
          <p>
            <span className="text-zinc-200">You own 100% of the content you generate</span> using the Service. We claim no
            ownership over your inputs or the outputs produced for you. You are free to use, modify, publish, and
            commercialize your generated content without attribution to IndieLaunchkit.
          </p>
        </Section>

        <Section heading="4. Acceptable Use">
          <p>You agree not to use the Service to:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Generate unlawful, infringing, hateful, or deceptive content.</li>
            <li>Violate the intellectual property or rights of others.</li>
            <li>Attempt to reverse engineer, overload, or disrupt the Service or its infrastructure.</li>
            <li>Resell or redistribute the Service itself without permission.</li>
          </ul>
        </Section>

        <Section heading="5. Payments & Billing">
          <p>Paid plans are processed by Paddle as our Merchant of Record, who handles billing, taxes, and refunds in accordance with their policies. Subscription terms and pricing are presented at checkout.</p>
        </Section>

        <Section heading="6. Limitation of Liability">
          <p>
            To the maximum extent permitted by law, IndieLaunchkit shall not be liable for any indirect, incidental,
            special, consequential, or punitive damages, or any loss of profits or revenues, arising from your use of the
            Service. Our total liability shall not exceed the amount you paid us in the twelve months preceding the claim.
          </p>
        </Section>

        <Section heading="7. Disclaimer on AI Output">
          <p>AI-generated content may contain inaccuracies. You are responsible for reviewing and verifying all output before publishing it to your Steam store or community.</p>
        </Section>

        <Section heading="8. Termination">
          <p>You may stop using the Service and request account deletion at any time. We may suspend or terminate accounts that violate these Terms.</p>
        </Section>

        <Section heading="9. Changes to These Terms">
          <p>We may update these Terms from time to time. Material changes will be communicated via the Service or email. Continued use after changes constitutes acceptance.</p>
        </Section>

        <Section heading="10. Contact">
          <p>
            Questions about these Terms? Contact us at{" "}
            <a href="mailto:contact@getindielaunchkit.com" className="text-teal-300 hover:text-teal-300 underline underline-offset-2" data-testid="terms-contact-email">
              contact@getindielaunchkit.com
            </a>.
          </p>
        </Section>
      </LegalShell>
    </div>
  );
};

export default Terms;
